import { render, staticRenderFns } from "./drawer-areas-staffs.vue?vue&type=template&id=bba2970a&"
import script from "./drawer-areas-staffs.vue?vue&type=script&lang=js&"
export * from "./drawer-areas-staffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports